module.exports = __webpack_public_path__ + "static/media/event-services-img19.7bc664ff.jpg";